import { Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import PropTypes from "prop-types";
import { rewampPalette } from "../theme";

const VARIANT_STYLES = {
  error: {
    bgcolor: rewampPalette.feedbackBanner.errorBg,
    color: rewampPalette.feedbackBanner.error,
    Icon: ErrorOutlineIcon,
  },
  warning: {
    bgcolor: rewampPalette.feedbackBanner.warningBg,
    color: rewampPalette.feedbackBanner.warning,
    Icon: ScheduleOutlinedIcon,
  },
};

/**
 * Figma 520-4764 / 520-4894 — inline feedback banner for onboarding OTP
 * and registration submit errors.
 */
export const RewampFeedbackBanner = ({ variant = "error", message, sx = {} }) => {
  if (!message) return null;
  const { bgcolor, color, Icon } = VARIANT_STYLES[variant] ?? VARIANT_STYLES.error;

  return (
    <Box
      role="alert"
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 0.75,
        bgcolor,
        color,
        px: 1.5,
        py: 1.25,
        borderRadius: "6px",
        width: "100%",
        ...sx,
      }}
    >
      <Icon sx={{ fontSize: 16, mt: "1px", flexShrink: 0 }} aria-hidden="true" />
      <Typography component="span" sx={{ fontSize: 12, lineHeight: "18px" }}>
        {message}
      </Typography>
    </Box>
  );
};

RewampFeedbackBanner.propTypes = {
  variant: PropTypes.oneOf(["error", "warning"]),
  message: PropTypes.string,
  sx: PropTypes.object,
};

export default RewampFeedbackBanner;
